import React, {Component} from "react";

export default class ErrorAlert extends Component {

    constructor (props) {

        super(props);

    }

    handleClick () {

        this.props.action();

    }

    render () {

        return (
            <div
                className="alert alert-error alert-danger hr"
                role="alert"
            >
                <button
                    className="close"
                    data-dismiss="alert"
                    onClick={this.handleClick.bind(this)}
                    type="button"
                >
                    &times;
                </button>
                <strong>
                    {this.props.message ? this.props.message : "Error Saving Changes"}
                </strong>
            </div>
        );

    }

}
